export default class ValorSeloAto {

  constructor(valorSeloAto) {
    this.emolumento = valorSeloAto.valorEmol;
    this.fuju = valorSeloAto.valorFuju;
    this.fundimper = valorSeloAto.valorFundimper;
    this.fundep = valorSeloAto.valorFundep;
    this.fumorpge = valorSeloAto.valorFumorpge;
    this.selo = valorSeloAto.valorSelo;
    this.total =   (this.emolumento + this.fuju + this.fundimper + this.fundep + this.fumorpge + this.selo).toFixed(2);
  }
}



// WEBPACK FOOTER //
// ./src/domain/selo/valor-selo-ato.js